<template>
    <div class="tw-info-box-container">
        <div class="tw-info-box-overlay" v-on:click="closePromotion()"></div>
        <div class="tw-info-box" v-on:click.stop>
            <div class="tw-info-box--header">
                <h3 class=""> {{ promotion.name }}</h3>
            </div>

            <div class="tw-info-box--content">
                <p class="" v-if="promotion.description"> {{ promotion.description }}</p>
                <p class=""> Select {{ promotion.qualifying_quantity }} of this ticket type and get {{ promotion.apply_to_quantity }} of those tickets for free!</p>
            </div>

            <div class="tw-text--center">
                <button type="button" class="tw-btn__link" v-on:click="closePromotion()">
                    Close
                </button>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
    import { Vue } from "vue-property-decorator";
    import { Component, Prop } from "vue-property-decorator";
    import TicketWidgetComponent from '../../TicketWidgetComponent';
    import PromotionModel from "../../../models/Promotion";

    @Component({components: {}})

    export default class Promotion extends TicketWidgetComponent {
        @Prop() public promotion!: PromotionModel;

        mounted() {}

        /**
         * @desc sets up the initial load of the calendar view
         */
        closePromotion() {
            this.$root.$emit('closePromotion');
        }
    }
</script>
